import { useState, useCallback, useRef } from 'react';

const useSearch = (searchService, initialQuery = '') => {
  const [searchQuery, setSearchQuery] = useState(initialQuery);
  const [isSearching, setSearchStatus] = useState(false);
  const abortControllerRef = useRef(null);

  const searchRequest = useCallback(
    async (skip, take, sort) => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();
      const { signal } = abortControllerRef.current;

      try {
        setSearchStatus(true);

        const response = await searchService(skip, take, searchQuery, false, { signal }, sort);

        setSearchStatus(false);
        abortControllerRef.current = null;

        return response.data;
      } catch (error) {
        setSearchStatus(false);
        abortControllerRef.current = null;
        
        if (error.name !== 'AbortError') {
          console.log(error);
        }
        
        return { data: [], total: 0 };
      }
    },
    [searchQuery, searchService],
  );

  return {
    searchQuery,
    setSearchQuery,
    isSearching,
    searchRequest,
  };
};

export default useSearch;
